import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { FinanciacionPrivadaListComponent } from './financiacion-privada-list.component';
import { FinanciacionPrivadaService } from './financiacion-privada.service';

@Component({
    selector: 'convfact-financiacionprivadadelete',
    templateUrl: './financiacion-privada-dialog-delete.component.html',
    styleUrls: ['./financiacion-privada.component.css'],
    standalone: false
})
export class FinanciacionPrivadaDialogDeleteComponent {

  public uid: string = this.data.uid;
  public response_message: string;
  public response_error: boolean;

  constructor(
    public dialogRef: MatDialogRef<FinanciacionPrivadaListComponent>,
    public financiacionPrivadaService: FinanciacionPrivadaService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
  ) { }

  public delete() {
    this.financiacionPrivadaService.delete(this.uid)
      .then(res => {
        this.response_message = "La financiación se ha eliminado correctamente";
        this.response_error = false;
      }).catch(err => {
        this.response_message = "Ha ocurrido un error al eliminar la financiación";
        this.response_error = true;
      });
  }

  public closeDialog() {
    this.dialogRef.close();
  }
}
